import * as types from '../mutation-types';

export default {
	namespaced: true,

	state: {
		notifications: [],
	},

	actions: {
		fetchAll({ commit }, { fromDate, toDate }) {
			return window.axios.get('/PlannedVisits/Mine/Unread', {
				params: { fromDate, toDate },
				once: true
			}).then(({ data }) => {
				commit(types.STORE_NOTIFICATIONS, data);
				return data
			});
		},

		markAsRead({ commit }, { notificationId }) {
			return window.axios.put(`/PlannedVisitsNotification/${notificationId}`, null, { params: { notify: true } })
		}
	},

	mutations: {
		[types.STORE_NOTIFICATIONS](state, notifications) {
			state.notifications = notifications;
		}
	},

	getters: {
		getNotificationById: state => id => state.notifications.find(c => c.id === id)
	}
}